import { Navigate, Outlet } from "react-router-dom";
import type { RootState } from '../app/store';
import { useSelector } from "react-redux";

function ProtectedRoutes() {
    const isSignIn = useSelector((state: RootState) => state.auth.isSignIn);
    return !isSignIn ? <Outlet /> : <Navigate to="/" />;
}

export default ProtectedRoutes;